import { Flex } from '@chakra-ui/react';
import type { DashboardTodoSourceKey } from '@fluenceur/types';
import { Gift, MediaImageList, UserPlus, Wallet } from 'iconoir-react';

const ICONS: Record<DashboardTodoSourceKey, typeof Gift> = {
  applications: UserPlus,
  ugcDecisions: MediaImageList,
  blockedGifts: Gift,
  owedCommissions: Wallet,
};

/** The tile on the left of a to-do line, one icon per subject. */
export const TodoLineIcon = ({ lineKey }: { lineKey: DashboardTodoSourceKey }) => {
  const Icon = ICONS[lineKey];
  return (
    <Flex
      align="center"
      justify="center"
      boxSize="36px"
      flexShrink={0}
      borderRadius="10px"
      borderWidth="1px"
      borderColor="cardBorder"
      bg="background"
      color="ink"
      aria-hidden="true"
    >
      <Icon width={18} height={18} />
    </Flex>
  );
};
